/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable max-len */
import React, { useState, useContext, useCallback, useEffect } from 'react'
import { motion } from 'framer-motion';
import FilterModal from './FilterModal'
import moment from 'moment'
import { distributorService } from '../../../service/distributor.service';
import HeaderContext from '../../../Components/Context/HeaderContext';
import Pagination from '../../../Components/Pagination';
import OrderListingSkeleton from '../../MyOrders/OrderListingSkeleton';
import {PriceHandler} from '../../../redux/helper/CamelCase'
import EmptyOrderPage from '../../MyOrders/EmptyOrderPage';


const PendingOrderStatementReport = () => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [filterModal, setFilterModal] = useState(false);
    const [pendingOrderReportList, setPendingOrderReportList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [sortType, setsortType] = useState('ORDER_DATE+desc');
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [filterValue, setfilterValue] = useState('');
    const [emptyData, setEmptyData] = useState(false);
    const [Filter, setFilter] = useState({
        order_type:[],
    })
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');


    const DISTRIBUTOR = JSON.parse(localStorage.getItem('user')).profile;

    const handlePendingOrderReports = useCallback((() => {
        distributorService.MISPendingOrderReport(DISTRIBUTOR.ACCOUNT_NUMBER, currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setPendingOrderReportList(response.data.Items);
                setalldata(response.data.Items);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handleExport = useCallback((() => {
        distributorService.MISPendingOrderReport(DISTRIBUTOR.ACCOUNT_NUMBER, currentPage, sortType, searchValue, filterValue, exportSelected ).then((response) => {
            if (response.data.success_status) {
                SetSuccessMessage(response.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(response.data.url, '_blank');
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    useEffect(() => {
        handlePendingOrderReports();
    }, [handlePendingOrderReports]);

    return (
        <div className="md:px-[46px] px-4 sm:pt-[30px] pt-3.5">
            {(loading && !emptyData) ? <OrderListingSkeleton /> : (
                <div>
                    <div className="flex items-center pb-[10px] justify-between flex-wrap top-0 left-0 z-[6]"  style={{zIndex: '6'}} >
                        <h5 className="sm:text-xs10 text-lg font-semibold text-[#090406] lg:mb-0 mb-3">Pending Order Statement Report</h5> 
                        <div className="lg:mb-0 mb-3">
                            <div className="flex sm:mx-2 mx-0 items-center flex-wrap w-full">
                                <button 
                                    type="button" 
                                    className="flex items-center bg-[#F5F5FA] font-bold text-xs text-[#555259] border-2 border-[#E9EDF4] sm:py-2.5 py-1.5 px-5 rounded-[9px]" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#filtermodal"
                                    onClick={() => setFilterModal(true)}
                                >
                                    {filterValue === '' ? '' :<span className='mr-1'><img src="/images/red-button.png"></img></span>}Filter
                                </button>
                                <div className="pl-2 dropdown relative">
                                    <button 
                                        type="button" 
                                        id="exportDropdown" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false" 
                                        className="dropdown-toggle text-xs2 font-semibold text-[#555259] sm:py-2.5 py-1.5 sm:px-4 px-2 border border-[#555259] rounded-lg"
                                        onClick={()=>setexportClick(!exportClick)} 
                                    >
                                        Generate Report
                                    </button>
                                    <ul className={`dropdown-menu sm:min-w-[125px] min-w-[120px] ${exportClick ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-lg shadow-s2 sm:p-3.5 p-1.5`} 
                                        style={{zIndex: '9'}} 
                                        aria-labelledby="exportDropdown">
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"  
                                                href="#"
                                                onClick={() => {
                                                    setexportSelected('csv')}}
                                            >CSV</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => setexportSelected(`pdf-converter`)}
                                            >PDF</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => setexportSelected('excel')}
                                            >Excel</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="ml-3 relative cursor-pointer">
                                    <input type="text" 
                                        className="lg:w-[200px] w-[160px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0" 
                                        placeholder="Search"
                                        value={searchValue}
                                        onChange={(e) => {
                                            setsearchValue(e.target.value);
                                            setCurrentPage(1);
                                        }}
                                        autoComplete="off"
                                    />
                                    <img src="/images/search-box.svg" alt="icon" className="absolute top-1.5 right-1"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            {pendingOrderReportList.length > 0 && (
                                <div className="overflow-auto dropdown-menu pb-7 relative z-[6]" style={{height: 'calc(100vh - 297px)'}}>
                                    <table className="w-full table-auto relative">
                                        <thead className='sticky top-0 left-0 z-[1]'>
                                            <tr className="bg-[#555259] h-10">
                                                <th className="py-2.5 sm:px-7 px-3 rounded-bl-lg rounded-tl-lg min-w-[136px] bg-[#555259] text-start sticky left-0" scope="col">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Order No.
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[190px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                        Order Date
                                                        <a href="javascript:void(0)" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{ rotate: sortType === 'ORDER_DATE+asc' ? 180 : 0 }}
                                                                className={`${sortType === 'ORDER_DATE+desc' ? 'image-rotate' : ''}`}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    if (sortType === 'ORDER_DATE+asc') {
                                                                        setsortType('ORDER_DATE+desc');
                                                                    } else if (sortType === 'ORDER_DATE+desc') {
                                                                        setsortType('ORDER_DATE+asc');
                                                                    } else {
                                                                        setsortType('ORDER_DATE+asc');
                                                                    }
                                                                // setCurrentPage(1);
                                                                // setLoading(true);
                                                                }}
                                                            />
                                                        </a>
                                                        
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[190px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                                        Ordered Item Code
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[290px] text-start">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Description
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[112px] text-center">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        UoM
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[180px] text-center">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Pending Quantity
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[180px] rounded-br-lg rounded-tr-lg text-start">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Product Value
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pendingOrderReportList.length > 0 && pendingOrderReportList.map((item, idx) => (
                                                <tr key={idx} className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                                    <td className="sticky left-0 text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3" style={{background:'rgba(255, 255, 255, 0.45)',backdropFilter:'blur(5.5px)'}}>
                                                        {item?.ENQUIRY_ID}                       
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        {moment(item?.ORDER_DATE).format('DD-MMM-YYYY, HH:mm:ss')}                      
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        {item?.ORDERED_ITEM_CODE}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        <span className="more-lines" data-tooltip-target="tooltip-information" data-tooltip-placement="bottom" data-tooltip-trigger="hover" type="button">
                                                            {item?.DESCRIPTION}
                                                        </span>
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-center">
                                                        {item?.UOM}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-center">
                                                        {item?.PENDING_QUANTITY}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        {PriceHandler(item?.PRD_VALUE)}
                                                    </td>
                                                </tr> 
                                            ))}                                                                             
                                        </tbody>
                                    </table>
                                </div>
                            )}                
                            {!loading && pendingOrderReportList && pendingOrderReportList.length > 0 && (
                                <Pagination
                                    handlePageClick={handlePageClick}
                                    totalPage={totalPage}
                                    List={alldata}
                                    currentPage={currentPage}
                                />
                            )}
                        </div>
                        {filterModal &&
                        <FilterModal
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            Filter={Filter}
                            setFilter={setFilter}
                            handleFilter={handleFilter}
                            handlePendingOrderReports={handlePendingOrderReports}
                            SetSuccessMessage={SetSuccessMessage}
                            selected={selected}
                            setselected={setselected}  
                            filterValue={filterValue} 
                            setfilterValue={setfilterValue}                
                        />}
                    </div>
                </div>    
            )} 
            {emptyData && <EmptyOrderPage search="yes" text="no Pending Order Report" all={searchValue.length > 0 ? 'under searched term' : 'found'} />} 
        </div>
    )
}

export default PendingOrderStatementReport
